'use client';
import * as React from 'react';

var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M20.06 7.12a8.998 8.998 0 0 1 .002 9.762M16.047 8.453a5.017 5.017 0 1 1-7.096 7.095 5.017 5.017 0 0 1 7.096-7.095Z",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m14.82 7.551 2.584-3.139a1.003 1.003 0 0 1 1.483-.072l1.273 1.273a1.002 1.002 0 0 1-.072 1.483L16.95 9.68M10.179 16.45l-2.584 3.138a1.003 1.003 0 0 1-1.483.072l-1.273-1.273a1.002 1.002 0 0 1 .072-1.483L8.05 14.32M8.05 9.679 4.91 7.095a1.003 1.003 0 0 1-.072-1.483l1.273-1.273a1.002 1.002 0 0 1 1.483.072l2.584 3.139M16.95 14.321l3.138 2.584c.457.376.49 1.064.072 1.483l-1.273 1.273a1.002 1.002 0 0 1-1.483-.072L14.82 16.45",
    vectorEffect: "non-scaling-stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.382 19.56a8.998 8.998 0 0 1-9.763 0M4.939 7.118a8.998 8.998 0 0 0 0 9.763M17.38 4.44a8.998 8.998 0 0 0-9.763-.001",
    vectorEffect: "non-scaling-stroke"
  })));
};

export { SvgHelp as default };
//# sourceMappingURL=help.svg.js.map
